import React from 'react';
import { Control, FieldErrors, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { FieldTypeEnum } from '../../_types';
import { FormFieldInput } from '../../../_components/FieldInputs';
import { translate as t } from 'hooks/useTranslations';
import SingleSelectField from './SingleSelectField';

interface FieldTypeFieldsProps {
  control: Control<any>;
  errors: FieldErrors<any>;
  fieldType: FieldTypeEnum;
  getValues?: any;
  setValue: any;
  fieldId?: number;
  isEditing?: boolean;
  isDraft?: boolean;
}

const FieldTypeFields: React.FC<FieldTypeFieldsProps> = ({
  control,
  errors,
  fieldType,
  getValues,
  setValue,
  fieldId,
  isEditing = false,
  isDraft = true,
}) => {
  if (fieldType === 'SingleSelect') {
    // Use the existing SingleSelectField for complex option management
    return (
      <SingleSelectField
        control={control}
        errors={errors}
        getValues={getValues}
        setValue={setValue}
        fieldId={fieldId}
        isEditing={isEditing}
        isDraft={isDraft}
      />
    );
  }

  if (fieldType === 'Attachment') {
    return (
      <Controller
        name='label'
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label={t('performanceReporting.fieldBank.form.label')}
            required
            fullWidth
            error={!!errors.label}
            helperText={(errors.label?.message as string) || ''}
          />
        )}
      />
    );
  }

  return (
    <>
      {/* Label field - common for all field types */}
      <Controller
        name='label'
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label={t('performanceReporting.fieldBank.form.label')}
            required
            fullWidth
            error={!!errors.label}
            helperText={(errors.label?.message as string) || ''}
          />
        )}
      />

      {/* Default Value field - using _lex FormFieldInput */}
      <FormFieldInput
        fieldType={fieldType}
        control={control}
        errors={errors}
        name='defaultValue'
        label={t('performanceReporting.fieldBank.form.defaultValue')}
        showTimezone={true}
      />
    </>
  );
};

export default FieldTypeFields;
